import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {BrowserSessionComponent} from "./browsersession.component";
import {TooltipModule} from 'primeng/tooltip';
import {WmDateFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-date-format.pipe';

@NgModule({
    declarations: [
        BrowserSessionComponent
    ],
    imports: [CommonModule, TooltipModule, WmDateFormatPipe],
    exports: [
        BrowserSessionComponent
    ]
})
export class BrowserSessionModule { }
